import { pageView, transitionFinished, transitionStarted } from '@wix/bi-logger-top-funnel-data/v2'
import webBiLogger from '@wix/web-bi-logger'
import { Logger } from '@wix/web-bi-logger/dist/src/types'

import { Direction, Monitoring, PageViewParams, TransitionFinishedParams, TransitionStartedParams } from './Monitoring'

export class FlowMonitoring implements Monitoring {
  private readonly logger: Logger
  private originId: string | undefined = undefined
  private direction: Direction = 'forward'

  constructor(private readonly flowId?: string) {
    this.logger = webBiLogger.factory().logger()
  }

  async sendPageView({ pageId }: PageViewParams) {
    await this.logger.report(pageView({ flow: this.flowId, page: pageId }))
  }

  async sendTransitionStarted(transitionParams: TransitionStartedParams) {
    const { destinationId, originId, direction = 'forward', isExternal = false } = transitionParams

    await this.logger.report(
      transitionStarted({
        flow: this.flowId,
        destination: destinationId,
        origin: originId,
        direction,
        is_external: isExternal,
      }),
    )
    this.originId = originId
    this.direction = direction
  }

  async sendTransitionFinished(transitionParams: TransitionFinishedParams) {
    if (!this.originId) {
      return
    }
    const { destinationId } = transitionParams

    await this.logger.report(
      transitionFinished({
        flow: this.flowId,
        destination: destinationId,
        origin: this.originId,
        direction: this.direction,
        is_external: false,
      }),
    )
    this.originId = undefined
  }
}
